import React, { useEffect, useState } from "react";
import { Form, Input, Button, Typography, Row, Col } from "antd";
import Utilities from "../dependencies/custom/react-utilities";
import { useLocation, useNavigate } from "react-router-dom";
import Settings from "../dependencies/custom/settings";
import ValuesStore from "../store/values-store";

const { Title, Text } = Typography;

export default function OtpPage() {
  const valuesStore = ValuesStore();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const otpLength = 6;

  const { user } = location?.state || {};

  const handleSubmit = async (values) => {
    setLoading(loading);
    const res = await Utilities.fetchWithAuth(
      "POST",
      `${Settings?.urls?.auth?.OTPVerify}/${user?.id}`,
      { otp: values?.OTP },
      navigate,
    );
    if (res.ok) {
      valuesStore.resetAuthState?.();
      Utilities.setCookie("access", res?.data?.access);
      Utilities.setCookie("refresh", res?.data?.refresh);
      valuesStore.setValue("user", res?.data?.user);
      valuesStore.setValue("admissions", res?.data?.admissions);
      sessionStorage.setItem("user", JSON.stringify(res?.data?.user));
      sessionStorage.setItem(
        "admissions",
        JSON.stringify(res?.data?.admissions),
      );
      Utilities.setSessionLock(res?.data?.user?.id, {
        user: res?.data?.user,
        admissions: res?.data?.admissions,
      });
      navigate("../../welcome/me", {
        state: { user: res?.data?.user, admissions: res?.data?.admissions },
      });
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
    setLoading(false);
  };

  async function getOTP() {
    if (!user || !user?.id) {
      navigate("../signin", { replace: true });
      return;
    }
    const res = await Utilities.fetchWithAuth(
      "POST",
      `${Settings?.urls?.auth?.OTPSend}/${user?.id}`,
      { user_id: user?.id },
      navigate,
    );
    if (res.ok) {
      Utilities.showNotification(
        undefined,
        "An OTP has been sent to your email. Please check your email and enter the OTP that has been sent to you",
        "text-success",
      );
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
  }

  useEffect(() => {
    getOTP();
  }, []);

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "80px auto",
        padding: "40px",
        border: "1px solid #f0f0f0",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        textAlign: "center",
      }}
    >
      <Title level={3}>Verify OTP</Title>
      <Text type="secondary">Enter the 6-digit code sent to your email</Text>

      <Form
        form={form}
        onFinish={handleSubmit}
        style={{ marginTop: 24 }}
        layout="inline"
      >
        <Form.Item
          className="w-100"
          name="OTP"
          rules={[{ required: true, message: "Please enter OTP" }]}
        >
          <Input.OTP
            maxLength={1}
            style={{
              width: "100%",
              textAlign: "center",
              fontSize: "18px",
            }}
            onChange={(value) => {
              if (value.length === otpLength) {
                setLoading(true);
                form.submit(); // auto-submit when last digit entered
              }
            }}
          />
        </Form.Item>

        <Button
          loading={loading}
          type="primary"
          htmlType="submit"
          block
          style={{ marginTop: 24 }}
        >
          Verify
        </Button>
      </Form>

      <Button type="link" onClick={getOTP} style={{ marginTop: 12 }}>
        Resend OTP
      </Button>
    </div>
  );
}
